import React from "react";
import { CalendarDays, CheckCircle2, Clock3, Plus, Receipt, Users } from "lucide-react";
import { Button } from "@/components/ui/button";

export function MobileAgendaActions({ onToday, onNow, onSchedule }: { onToday: () => void; onNow?: () => void; onSchedule: () => void }) {
  return (
    <div className="grid grid-cols-3 gap-2 border-b border-border bg-background px-2 py-2 md:hidden" data-testid="mobile-agenda-actions">
      <Button size="sm" variant="outline" className="h-9" onClick={onToday}><CalendarDays className="mr-1.5 h-4 w-4" />Hoje</Button>
      <Button size="sm" variant="outline" className="h-9" onClick={onNow ?? onToday}><Clock3 className="mr-1.5 h-4 w-4" />Agora</Button>
      <Button size="sm" className="h-9" onClick={onSchedule}><Plus className="mr-1.5 h-4 w-4" />Agendar</Button>
    </div>
  );
}

export function MobileSaleActionBar({ visible, disabled, pending, label, onSubmit }: { visible: boolean; disabled: boolean; pending: boolean; label: string; onSubmit: () => void }) {
  if (!visible) return null;
  return (
    <Button data-testid="mobile-sale-action" className="md:hidden fixed bottom-[calc(5rem+env(safe-area-inset-bottom))] left-4 right-4 z-40 h-12 shadow-lg" disabled={disabled} onClick={onSubmit}>
      {pending ? <span className="mr-2 animate-pulse">Processando</span> : <Receipt className="mr-2 h-4 w-4" />}
      {label}
    </Button>
  );
}

export function MobileQueueStatusBar({ waiting, preparing, called, inService }: { waiting: number; preparing: number; called: number; inService: number }) {
  return (
    <div className="grid grid-cols-4 gap-1 border-b border-white/5 bg-black/20 px-3 py-2 sm:hidden" data-testid="mobile-queue-status" role="status" aria-live="polite" aria-label="Resumo atualizado da fila">
      <QueueStatus label="Aguardando" value={waiting} />
      <QueueStatus label="Montagem" value={preparing} />
      <QueueStatus label="Chamadas" value={called} active={called > 0} />
      <QueueStatus label="Em atendimento" value={inService} />
    </div>
  );
}

function QueueStatus({ label, value, active = false }: { label: string; value: number; active?: boolean }) {
  return <div className={`rounded-lg px-1.5 py-1 text-center ${active ? "bg-amber-400/15 text-amber-200" : "bg-white/5 text-white/70"}`}><div className="flex justify-center gap-1 text-[10px]"><Users className="h-3 w-3" />{label}</div><p className="text-base font-bold leading-tight">{value}</p></div>;
}
